import * as yup from "yup";
import { ExportSettingsValidationSchema } from "../../SettingsPage/ExportSettings/ExportSettingsForm";

const savedSearchValidation = yup.object({
  name: yup.string()
    .max(40, 'Name is too long')
    .required('Name is required'),
  columnList: yup.array().min(1, 'At least one column should be chosen'),
}).concat(ExportSettingsValidationSchema);

export default savedSearchValidation;